export enum HsaLmnLookupQueryKind {
  Email = "email",
  OrderId = "order_id",
  CheckoutId = "checkout_id",
  MerchantOrderReference = "merchant_order_reference",
}
